/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryConfigurationManagement {
    getFixupPrototypeFunction() { return InventoryConfigurationManagement.fixupPrototype; }

    static newInstance(model: Partial<InventoryConfigurationManagement>): InventoryConfigurationManagement {
        let obj = Object.assign(new InventoryConfigurationManagement(), model);
        InventoryConfigurationManagement.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryConfigurationManagement>): InventoryConfigurationManagement {
        if (!model) return null;
        return InventoryConfigurationManagement.newInstance(<InventoryConfigurationManagement> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryConfigurationManagement) {
        if (!obj) return;

        models.InventoryConfigurationManagement.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryConfigurationManagement): boolean {
        Object.setPrototypeOf(obj, InventoryConfigurationManagement.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Value identifier for the option
     */
    change_tracking_reference: boolean;

}
